/**
 * Product images helpers shared by product forms and list normalizers.
 * Storage shape: [{ url, index }]
 */
export const IMAGE_LIMIT = 5

export function normalizeProductImages(images, fallbackUrl = null) {
  const raw = Array.isArray(images) ? images : []
  const cleaned = []

  for (const item of raw) {
    if (typeof item === 'string') {
      const url = item.trim()
      if (url) cleaned.push({ url, index: cleaned.length })
      continue
    }
    if (!item || typeof item !== 'object') continue
    const url = String(item.url ?? item.imageUrl ?? item.image_url ?? '').trim()
    if (!url) continue
    const index = Number.parseInt(String(item.index), 10)
    cleaned.push({
      url,
      index: Number.isFinite(index) ? index : cleaned.length,
    })
  }

  if (cleaned.length === 0) {
    const fallback = String(fallbackUrl ?? '').trim()
    if (fallback) return [{ url: fallback, index: 0 }]
    return []
  }

  cleaned.sort((a, b) => a.index - b.index || a.url.localeCompare(b.url))
  return cleaned.map((item, index) => ({ url: item.url, index }))
}

export function primaryProductImageUrl(images, fallbackUrl = null) {
  const list = normalizeProductImages(images, fallbackUrl)
  return list[0]?.url ?? (String(fallbackUrl ?? '').trim() || null)
}

export function reindexProductImages(images) {
  return normalizeProductImages(images).map((item, index) => ({
    url: item.url,
    index,
  }))
}
